import { Box, styled } from "@mui/material";

export const ServerErrorContainer = styled(Box)(() => ({
  position: "relative",
  paddingTop: "74px",
  color: "#000",
  paddingBottom: "40px",

  ".hero_container": {
    display: "flex",
    position: "relative",
    minHeight: "620px",
    backgroundColor: "#fff",
    borderRadius: "40px",
    overflow: "hidden",

    ".hero_heading": {
      fontStyle: "normal",
      fontWeight: "700",
      color: "#000",
      marginBottom: "24px",
      textAlign: "left",
      " @media (min-width: 768px)": {
        fontSize: "2.875rem",
      },
    },

    h6: {
      fontSize: "2.875rem",
      fontWeight: "300",
      textAlign: "left",
      color: "#000",
    },

    p: {
      marginBottom: "40px",
      color: "#000",
    },

    ".hero_left": {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      justifyContent: "space-between",
      position: "relative",
      zIndex: "10",
      paddingLeft: "20px",
      paddingRight: "40px",
      paddingTop: "40px",

      "@media (min-width: 992px)": {
        paddingLeft: "100px",
      },

      " @media (min-width: 1181px)": {
        background: "transparent",
      },

      ".hero_content": {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
      },
    },

    ".hero_right": {
      //display: 'none',
      position: "relative",
      bottom: 0,
      top: 0,
      left: 0,
      right: 0,
      flex: 1,
      display: "flex",
      justifyContent: "flex-end",

      "@media (min-width: 768px)": {
        position: "absolute",
      },

      img: {
        maxWidth: "700px",
        objectFit: "cover",
        height: "100%",
        zIndex: 10,
      },
    },
  },
}));
